import {
  faArrowAltToBottom,
  faArrowAltToTop,
  faBell,
  faEllipsisV,
  faFileInvoiceDollar,
  faGavel,
  faShoppingCart,
  faTag,
  faUserCheck,
} from '@fortawesome/pro-solid-svg-icons';
import type { ReactNode } from 'react';

import {
  MY_SORARE_AUCTIONS,
  MY_SORARE_FOLLOWS,
  MY_SORARE_INSTANT_BUYS,
  MY_SORARE_NEW,
  MY_SORARE_OFFERS_RECEIVED,
  MY_SORARE_OFFERS_SENT,
  MY_SORARE_PLAYERS_NOTIFICATIONS,
  MY_SORARE_PURCHASES,
  MY_SORARE_SALES,
  MY_SORARE_TRANSACTIONS,
} from '@sorare/core/src/constants/__generated__/routes';
import { navLabels } from '@sorare/core/src/lib/glossary';
import type { LinkSet } from '@sorare/core/src/routing/RoutedSidebarMenu';
import { RoutedSidebarMenu } from '@sorare/core/src/routing/RoutedSidebarMenu';

import { MySorarePage, TITLES } from '../common/pages';

interface Props {
  children: ReactNode;
  startWithOpenedMenu?: boolean;
}

const links: LinkSet<MySorarePage> = {
  new: {
    to: MY_SORARE_NEW,
    icon: faEllipsisV,
    label: TITLES.new,
  },
  auctions: {
    to: MY_SORARE_AUCTIONS,
    icon: faGavel,
    label: TITLES.auctions,
  },
  primary_offers: {
    to: MY_SORARE_INSTANT_BUYS,
    icon: faTag,
    label: TITLES.primary_offers,
  },
  sales: {
    to: MY_SORARE_SALES,
    icon: faTag,
    label: TITLES.sales,
  },
  purchases: {
    to: MY_SORARE_PURCHASES,
    icon: faShoppingCart,
    label: TITLES.purchases,
  },
  offers_received: {
    to: MY_SORARE_OFFERS_RECEIVED,
    icon: faArrowAltToBottom,
    label: TITLES.offers_received,
  },
  offers_sent: {
    to: MY_SORARE_OFFERS_SENT,
    icon: faArrowAltToTop,
    label: TITLES.offers_sent,
  },
  follows: {
    icon: faUserCheck,
    to: MY_SORARE_FOLLOWS,
    label: TITLES.follows,
  },
  players_notifications: {
    icon: faBell,
    to: MY_SORARE_PLAYERS_NOTIFICATIONS,
    label: TITLES.players_notifications,
  },
  transactions: {
    icon: faFileInvoiceDollar,
    to: MY_SORARE_TRANSACTIONS,
    label: TITLES.transactions,
  },
};

export const MySorareLayout = ({ children, startWithOpenedMenu }: Props) => {
  return (
    <RoutedSidebarMenu<MySorarePage>
      linkIds={Object.values(MySorarePage)}
      links={links}
      pageTitle={navLabels.mySorare}
      startWithOpenedMenu={startWithOpenedMenu}
    >
      {children}
    </RoutedSidebarMenu>
  );
};
